import React, { useState, useEffect } from 'react'
import { AddTable, IsAddBtn, MobileTable, NoteTable, TableHeader } from './styles/modalStyles'
import { message, Select } from 'antd'
import { FaPlus } from 'react-icons/fa6'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import { useLearningNote } from '../hooks/LearningNote'
import { useStudyReportTemplates } from '../hooks/StudyReportTemplates'

export const AddLectureLearningNote = ({
	isAdd,
	setIsAdd,
	isAddMobile,
	setIsAddMobile,
	selectLecture,
	formattedTime,
	todayMonthNoteDate,
	monthNoteDate
}) => {
	const { data: token } = useToken()
	const { mutate: LearningNoteMutate } = useLearningNote(selectLecture?.id)
	const { templates } = useStudyReportTemplates('daily')
	const [content, setContent] = useState('')
	const [homework, setHomework] = useState('')
	const [memo, setMemo] = useState('')
	const [selectedTemplateId, setSelectedTemplateId] = useState<number | undefined>(undefined)

	const saveContent = e => {
		setContent(e.target.value)
	}
	const saveHomework = e => {
		setHomework(e.target.value)
	}
	const saveMemo = e => {
		setMemo(e.target.value)
	}

	const handleAddButtonClick = () => {
		if (content === '') {
			message.error('학습내용은 필수입력 입니다.')
			return
		}
		API.post('/dashboard/lecture/' + selectLecture?.id + '/report', token + '', {
			type: 1,
			createdAt: todayMonthNoteDate === monthNoteDate ? '' : monthNoteDate,
			content,
			homework,
			memo,
		})
			.then((res: any) => {
				if (res.result.success) {
					message.success('추가되었습니다')
					setContent('')
					setHomework('')
					setMemo('')
					setSelectedTemplateId(undefined)
					setIsAdd(false)
					LearningNoteMutate()
				}
			})
			.catch((err: any) => { })
	}

	const mobileAddButtonClick = () => {
		if (content.trim() === '') {
			message.error('학습내용은 필수입력 입니다.')
			return
		}

		API.post('/dashboard/lecture/' + selectLecture?.id + '/report', token + '', {
			type: 1,
			createdAt: todayMonthNoteDate === monthNoteDate ? '' : monthNoteDate,
			content,
			homework,
			memo,
		})
			.then((res: any) => {
				if (res.result.success) {
					message.success('추가되었습니다')
					setContent('')
					setHomework('')
					setMemo('')
					setSelectedTemplateId(undefined)
					setIsAddMobile(false)
				}
			})
			.catch((err: any) => { })
	}

	const handleKeyDown = e => {
		if (e.key === 'Enter' && !e.shiftKey) {
			// 엔터 키를 누르고, shift 키를 누르지 않은 경우
			e.preventDefault() // 기본 엔터 동작 방지
			setContent(prevContent => prevContent + '\n')
		}
	}

	const handleTemplateChange = (templateId: number) => {
		setSelectedTemplateId(templateId)
		const template = templates?.find((t: any) => t.id === templateId)
		if (template) {
			// 덮어쓰기 방식으로 적용
			setContent(template.content || '')
			setHomework(template.homework || '')
			setMemo(template.memo || '')
		}
	}

	return (
		<>
			{isAdd ? (
				<>
					<AddTable>
						<TableHeader>
							<p>내용추가</p>
							<div style={{ marginTop: '8px', marginBottom: '8px' }}>
								<Select
									placeholder="템플릿 선택"
									style={{ width: '100%', maxWidth: '300px' }}
									value={selectedTemplateId}
									onChange={handleTemplateChange}
									allowClear>
									{templates?.map((template: any) => (
										<Select.Option key={template.id} value={template.id}>
											{template.title}
										</Select.Option>
									))}
								</Select>
							</div>
						</TableHeader>
						<NoteTable>
							<tr>
								<th>학습내용</th>
								<th>과제</th>
								<th>비고</th>
							</tr>
							<tr>
								<td>
									<textarea
										style={{ width: '100%' }}
										className="contentInput"
										autoFocus
										placeholder="학습내용 입력(필수) &#13;&#10;줄바꿈은 shift + Enter"
										value={content}
										onChange={saveContent}
										onKeyDown={handleKeyDown}
									/>
								</td>
								<td className="assignment">
									<textarea
										className="assignmentInput"
										value={homework}
										onChange={saveHomework}
										onKeyDown={e => {
											if (e.key === 'Enter' && !e.shiftKey) {
												// 엔터 키를 누르고, shift 키를 누르지 않은 경우
												e.preventDefault() // 기본 엔터 동작 방지
												setHomework(prevContent => prevContent + '\n')
											}
										}}
									/>
								</td>
								<td style={{ position: 'relative', top: 0 }}>
									<input style={{ position: 'relative', top: -76 }} type="text" value={memo} onChange={saveMemo} />
								</td>
								<td style={{ position: 'relative', top: 0 }}>
									<button onClick={handleAddButtonClick} style={{ position: 'relative', top: -76 }}>추가</button>
								</td>
								<td style={{ position: 'relative', top: 0 }}>
									<button onClick={() => setIsAdd(false)} style={{ position: 'relative', top: -76 }}>취소</button>
								</td>
							</tr>
						</NoteTable>
					</AddTable>
				</>
			) : (
				<IsAddBtn className="notMobile" onClick={() => setIsAdd(true)}>
					<FaPlus />
					<p>추가</p>
				</IsAddBtn>
			)}
			{isAddMobile ? (
				<MobileTable>
					<div className="tableHeader">
						<p></p>
						<p></p>
					</div>
					<div style={{ padding: '8px' }}>
						<Select
							placeholder="템플릿 선택"
							style={{ width: '100%' }}
							value={selectedTemplateId}
							onChange={handleTemplateChange}
							allowClear>
							{templates?.map((template: any) => (
								<Select.Option key={template.id} value={template.id}>
									{template.title}
								</Select.Option>
							))}
						</Select>
					</div>
					<div className="tableMain">
						<div className="content">
							<h1>
								학습
								<br />
								내용
							</h1>
							<p>
								<input
									className="contentMobile"
									type="text"
									placeholder="학습내용 입력"
									value={content}
									onChange={saveContent}
								/>
							</p>
						</div>
						<div className="assignment">
							<h1>과제</h1>
							<p>
								<textarea
									className="assignmentMobile"
									value={homework}
									onKeyDown={e => {
										if (e.key === 'Enter' && !e.shiftKey) {
											// 엔터 키를 누르고, shift 키를 누르지 않은 경우
											e.preventDefault() // 기본 엔터 동작 방지
											setHomework(prevContent => prevContent + '\n')
										}
									}}
									placeholder="내용작성"
									onChange={saveHomework}
								/>
							</p>
						</div>
					</div>
					<div className="addbtn">
						<button onClick={mobileAddButtonClick}>추가</button>
						<button onClick={() => setIsAddMobile(false)}>취소</button>
					</div>
				</MobileTable>
			) : (
				<IsAddBtn className="mobile" onClick={() => setIsAddMobile(true)}>
					<FaPlus />
					<p>추가</p>
				</IsAddBtn>
			)}
		</>
	)
}
